import { ChangeEvent } from 'react'
import { TextField } from '@mui/material'
import Geocode from 'react-geocode'

import { useStyles } from './styles'
import { HelperWrapper } from '../helper-wrapper'

Geocode.setApiKey(String(process.env.REACT_APP_GOOGLE_MAPS_API_KEY))

interface IProps {
  handleAddress: (address: string) => void
  handleLatAndLong: (props: { lat: number; lng: number }) => void
  isDisabled?: boolean
  isRequired?: boolean
  center: {
    lat: number
    lng: number
  }
}

const GoogleMapLatAndLongInput = ({
  handleAddress,
  handleLatAndLong,
  center,
  isDisabled,
  isRequired,
}: IProps) => {
  const classes = useStyles()

  const handleLatChange = async (e: ChangeEvent<HTMLInputElement>) => {
    handleLatAndLong({ lat: Number(e.target.value), lng: center.lng })
    const address = await Geocode.fromLatLng(e.target.value, String(center.lng))
    address?.results?.[0]?.formatted_address && handleAddress(address.results[0].formatted_address)
  }

  const handleLngChange = async (e: ChangeEvent<HTMLInputElement>) => {
    handleLatAndLong({ lat: center.lat, lng: Number(e.target.value) })
    const address = await Geocode.fromLatLng(String(center.lat), e.target.value)
    address?.results?.[0]?.formatted_address && handleAddress(address.results[0].formatted_address)
  }

  return (
    <div className={classes.coordsWrapper}>
      <TextField
        disabled={isDisabled}
        autoComplete="off"
        fullWidth
        id="latitude"
        label={
          <HelperWrapper
            t={'latitude-input-label'}
            isInputLable
            isMandatory={isRequired}
            isColorInherited
          />
        }
        type="number"
        InputLabelProps={{ shrink: true, className: classes.coordInput }}
        value={isRequired ? center.lat : 0}
        onChange={handleLatChange}
        variant="standard"
        InputProps={{ className: classes.coordInput }}
      />
      <TextField
        disabled={isDisabled}
        autoComplete="off"
        fullWidth
        id="longitude"
        label={
          <HelperWrapper
            t={'longitude-input-label'}
            isInputLable
            isMandatory={isRequired}
            isColorInherited
          />
        }
        type="number"
        InputLabelProps={{ shrink: true, className: classes.coordInput }}
        value={isRequired ? center.lng : 0}
        InputProps={{ className: classes.coordInput }}
        onChange={handleLngChange}
        variant="standard"
      />
    </div>
  )
}

export { GoogleMapLatAndLongInput }
